import { getCourses } from "../../../common/api/decimal/methods/course.ts";
import { LoaderFunction, useLoaderData } from "react-router-dom";
import { areCourseIdsTheSame } from "../my-courses/coursesUtils.ts";

interface CourseRedirectLoaderData {
  enrolled: boolean;
}

const getEnrolledCourseIds = () =>
  getCourses().then(({ data }) => data?.map((course) => course.id) ?? []);

export const courseRedirectLoader: LoaderFunction = async ({
  params,
}): Promise<CourseRedirectLoaderData> => {
  const enrolledCourses = await getEnrolledCourseIds();
  const enrolled = !!enrolledCourses.find((id) =>
    areCourseIdsTheSame(id, params.section!)
  );
  return { enrolled };
};

export function useCourseRedirectLoaderData(): CourseRedirectLoaderData {
  return useLoaderData<CourseRedirectLoaderData>();
}
